define([
    'backbone'
], function(
    ) {
    /**
     * @exports models/blob-model
     */
    var BlobModel = Backbone.Model.extend({
        /**
         * Backbone.Model を extend した BlobModel を定義する
         */
        defaults: {
            filename: '',
            blob_id: null,
            content_type: '',
            size: 0,
            created_at: null,
            histories: []
        },

        initialize: function() {
            this._active = false;
            _.bindAll(this, 'isActive', 'activate', 'deactivate', 'toggle');
        },

        url: function() {
            return `/blobs/${this.id}`;
        },

        isImage: function() {
            return this.get('content_type').indexOf('image/') == 0;
        },

        prettySizeString: function() {
            var size = this.get('size');
            if(size > 1000 * 1000) {
                return Math.round(size / 100 / 1000) / 10 + 'MB';
            }
            if(size > 1000) {
                return Math.round(size / 100) / 10 + 'KB';
            }
            return size + 'B';
        },

        getFileType: function() {
            var filename = this.get('filename');
            if(filename.match(/(\.doc$|\.docx$)/)) {
                return 'file-word';
            }
            if(filename.match(/(\.xls|\.xlsx)/)) {
                return 'file-excel';
            }
            if(filename.match(/(\.ppt$|\.pptx$)/)) {
                return 'file-powerpoint';
            }
            if(filename.match(/\.pdf$/)) {
                return 'file-pdf';
            }
            return 'file';
        },

        getMarkdownLink: function() {
            var link = '';
            var filename = this.get('filename');
            const url = `/blobs/${this.id}`;
            if(this.isImage()) {
                link = `![${filename}](${url})`;
            } else {
                link = `[${filename}](${url})`;
            }
            return link;
        },

        isActive: function() {
            return this._active;
        },

        activate: function() {
            if (!this._active) {
                this._active = true;
                this.trigger('activate', this);
            }
        },

        deactivate: function() {
            if (this._active) {
                this._active = false;
                this.trigger('deactivate', this);
            }
        },

        toggle: function() {
            if (this._active) {
                this.deactivate();
            } else {
                this.activate();
            }
        }
    });

    return BlobModel;
});



// WEBPACK FOOTER //
// ./common/domain/entity/blob.js